import { Component } from "react";
import ReactTable from "./ReactTable";
import "./Table.css";
import "../../utils.css";
import { connect } from "react-redux";
import { setContextInfoOrderBy, setPageNumber, setPageSize } from "../../redux/contextInfos/contextInfosActions";
import { DEFAULT_PAGE_SIZE } from "../../redux/contextInfos/contextInfosConstants";

class TableWithPagination extends Component {
    onPageChange(pageIndex) {
        this.props.setPageNumber(pageIndex);
    }

    onPageSizeChange(pageSize, pageIndex) {
        this.props.setPageSize(pageSize, pageIndex);
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <ReactTable
                    {...this.props}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
                    minRows={this.props.minRows !== undefined ? this.props.minRows : 3}
                    defaultPageSize={
                        this.props.defaultPageSize !== undefined ? this.props.defaultPageSize : DEFAULT_PAGE_SIZE
                    }
                    pageSize={this.props.pageSize !== undefined ? this.props.pageSize : undefined}
                    showPagination={this.props.showPagination !== undefined ? this.props.showPagination : true}
                    pageSizeOptions={
                        this.props.pageSizeOptions !== undefined ? this.props.pageSizeOptions : [20, 80, 200, 500]
                    }
                    previousText="Précédent"
                    nextText="Suivant"
                    loadingText="Chargement..."
                    noDataText="Aucun résultat"
                    pageText="Page"
                    ofText="sur"
                    rowsText="lignes"
                    className="-striped col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                    style={{
                        height: "100%", // This will force the table body to overflow and scroll, since there is not enough room
                    }}
                    onPageChange={this.onPageChange.bind(this)}
                    onPageSizeChange={this.onPageSizeChange.bind(this)}
                    onSortedChange={(columnsToSort) => {
                        let columnToSort = columnsToSort[0];
                        this.props.setContextInfoOrderBy(columnToSort.id, columnToSort.desc);
                    }}
                    withPagination={true}
                />
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPageNumber: (pageIndex) => dispatch(setPageNumber(pageIndex)),
        setPageSize: (pageSize, pageIndex) => dispatch(setPageSize(pageSize, pageIndex)),
        setContextInfoOrderBy: (attribute, desc) => dispatch(setContextInfoOrderBy(attribute, desc)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableWithPagination);
